import React from 'react';
import { Stack, TextField, Typography, Alert } from '@mui/material';

interface DateRangeFormProps {
  startDate: string;
  endDate: string;
  company: string;
  center: string;
  error: unknown;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
}

export const DateRangeForm: React.FC<DateRangeFormProps> = ({
  startDate,
  endDate,
  company,
  center,
  error,
  onStartDateChange,
  onEndDateChange,
}) => {
  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      <Typography variant="body2" color="textSecondary">
        Export schedule data for {company} - {center}
      </Typography>

      {error ? (
        <Alert severity="error">
          Failed to export schedule data. Please try again.
        </Alert>
      ) : null}

      <TextField
        fullWidth
        label="Start Date"
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        required
      />

      <TextField
        fullWidth
        label="End Date"
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        required
      />

      <Typography variant="body2" color="textSecondary">
        The export will include all scheduled encounters within the selected date range, excluding cancelled cases.
      </Typography>
    </Stack>
  );
};
